import { makeStyles, createStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    footerContainer: {
      height: 50,
      marginTop: theme.spacing(3),
    },
    iconContainer: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      height: '100%',
      [theme.breakpoints.down('xs')]: {
        justifyContent: 'center',
      },
    },
    iconText: {
      color: '#364343',
      margin: '8px 0 10px 12px',
      fontSize: '11px',
      fontWeight: 500,
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1',
      letterSpacing: 'normal',
      marginRight: theme.spacing(3),
    },
    buttonContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
    },
    buttonContainerMobile: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginBottom: theme.spacing(4),
    },
  }),
);
export default useStyles;
